import { render, staticRenderFns } from "./PicUpload.vue?vue&type=template&id=121e452a&scoped=true"
import script from "./PicUpload.vue?vue&type=script&lang=js"
export * from "./PicUpload.vue?vue&type=script&lang=js"
import style0 from "./PicUpload.vue?vue&type=style&index=0&id=121e452a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121e452a",
  null
  
)

export default component.exports